import React, { useState, useRef } from 'react';
import { Fade } from 'react-awesome-reveal';
import emailjs from '@emailjs/browser';
import PageHeader from '../components/PageHeader';
import SuccessModal from '../components/SuccessModal';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [modal, setModal] = useState({
    show: false,
    title: '',
    message: '',
    type: 'success'
  });

  const closeModal = () => {
    setModal({ ...modal, show: false });
  };

  const form = useRef();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.name || !formData.email || !formData.message) {
      setModal({
        show: true,
        title: 'Missing Fields',
        message: 'Please fill in all required fields.',
        type: 'error'
      });
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log('SUCCESS!', result.text);
          setModal({
            show: true,
            title: 'Message Sent!',
            message: 'Thank you for contacting us. We will get back to you shortly.',
            type: 'success'
          });
          setFormData({ name: '', email: '', subject: '', message: '' });
        },
        (error) => {
          console.log('FAILED...', error.text);
          setModal({
            show: true,
            title: 'Sending Failed',
            message: 'Something went wrong. Please check your connection and try again.',
            type: 'error'
          });
        }
      );
  };

  const breadcrumb = [
    { label: 'Home', href: '/' },
    { label: 'Pages', href: '#' },
    { label: 'Contact', href: '/contact', active: true }
  ];

  return (
    <>
      <PageHeader title="Contact Us" breadcrumb={breadcrumb} />
      <div className="container-xxl py-6">
        <div className="container">
          <Fade triggerOnce>
            <div className="text-center mx-auto mb-5" style={{ maxWidth: '500px' }}>
              <p className="text-primarys text-uppercase mb-2">// Contact Us</p>
              <h1 className="display-6 mb-4">If You Have Any Query, Please Contact Us</h1>
            </div>
          </Fade>
          <div className="row g-0 justify-content-center">
            <div className="col-lg-8">
              <Fade delay={200} triggerOnce>
              <p className="text-center mb-4">The contact form is currently inactive. Get a functional and working contact form with Ajax & PHP in a few minutes. Just copy and paste the files, add a little code and you're done.</p>
              <form ref={form} onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                        required />
                      <label htmlFor="name">Your Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Your Email"
                        value={formData.email}
                        onChange={handleChange}
                        required />
                      <label htmlFor="email">Your Email</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="subject"
                        name="subject"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required />
                      <label htmlFor="subject">Subject</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        placeholder="Leave a message here"
                        id="message"
                        name="message"
                        style={{ height: '200px' }}
                        value={formData.message}
                        onChange={handleChange}
                        required></textarea>
                      <label htmlFor="message">Message</label>
                    </div>
                  </div>
                  <div className="col-12 text-center">
                    <button className="btn btn-primarys rounded-pill py-3 px-5" type="submit">Send Message</button>
                  </div>
                </div>
              </form>
              </Fade>
            </div>
          </div>
        </div>
      </div>
      <Fade triggerOnce>
        <div className="container-xxl py-6 px-0">
        <iframe
          className="w-100 mb-n2"
          style={{ height: '450px' }}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001156.4288297426!2d-78.01371936852176!3d42.72876761954724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York%2C%20USA!5e0!3m2!1sen!2sbd!4v1603794290143!5m2!1sen!2sbd"
          frameBorder="0"
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
          title="Location Map"></iframe>
        </div>
      </Fade>
      <SuccessModal
        show={modal.show}
        onClose={closeModal}
        title={modal.title}
        message={modal.message}
        type={modal.type}
      />
    </>
  );
};

export default Contact;






